__turbopack_context__.v({
  "container": "_3d51SW_container",
  "firstRowWrapper": "_3d51SW_firstRowWrapper",
  "footerColumns": "_3d51SW_footerColumns",
  "footerCopyText": "_3d51SW_footerCopyText",
  "footerMenuWrapper": "_3d51SW_footerMenuWrapper",
  "footerTitle": "_3d51SW_footerTitle",
  "footerTitleWrapper": "_3d51SW_footerTitleWrapper",
  "footerVerticlaLine": "_3d51SW_footerVerticlaLine",
  "socialWrapper": "_3d51SW_socialWrapper",
});
